export type DrillLevel = {
    order: number;
    label: string;
    data: DrillData[];
};

export interface DrillData { id: number; label: string; parentId?: number }

type ParsedCSVResult = {
    file?: File;
    drillLevels?: DrillLevel[];
    error?: string;
};

export const readCSVFile = async (
  file: File
): Promise<ParsedCSVResult> => {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {
      const csvData = (e.target?.result as string)
        .split('\n')
        .filter(line => line.trim() !== '');

      const columns = csvData.shift()?.split(',') ?? [];
      const drillLevels: DrillLevel[] = columns.map((label, index) => ({
        order: index,
        label: label.replace('\r', ''),
        data: []
      }));

      let emptyLabel = false;

      csvData.forEach((line: string) => {
        const values = line
          .split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
          .map(value => value.replace(/[\r"\\]/g, '').trim());

        values.forEach((value, index) => {
          if (value === '') emptyLabel = true;

          if (index === 0) {
            if (!drillLevels[index].data.some(item => item.label === value)) {
              drillLevels[index].data.push({ id: drillLevels[index].data.length, label: value });
            }
          } else if (index < drillLevels.length) {
            const parent = drillLevels[index - 1].data.find(item => item.label === values[index - 1]);
            if (parent && !drillLevels[index].data.some(item => item.label === value && item.parentId === parent.id)) {
              drillLevels[index].data.push({ id: drillLevels[index].data.length, parentId: parent.id, label: value });
            }
          }
        });
      });

      if (emptyLabel) {
        resolve({
          error: 'Error: The file contains empty labels. Please fix the issue and try again.'
        });
      } else {
        const newBlob = new Blob([JSON.stringify(drillLevels)], { type: 'application/json' });
        const newFile = new File([newBlob], file.name, {type: 'application/json', lastModified: Date.now()});
        resolve({ file: newFile, drillLevels });
      }
    };

    reader.onerror = reject;
    reader.readAsText(file);
  });
};
